import gql from 'graphql-tag';

export const GetAuditLogsQuery = gql`
  query getAudits($filter: getAuditsFilterInput, $order: getAuditsSortFilterInput, $skip: Int, $take: Int) {
    getAuditLogs(filter: $filter, order: $order, skip: $skip, take: $take, fetchUserData: true) {
      totalCount
      queryCount
      audits {
        id
        type
        who
        whoUser
        whoUserData {
          id
          firstName
          lastName
        }
        target
        targetUser
        targetUserData {
          id
          firstName
          lastName
        }
        initiatedByRole
        updatedAt
        createdAt
      }
    }
  }
`;
